var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuarantine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66667 8.77908C7.51932 8.77908 7.37802 8.83761 7.27383 8.9418C7.16964 9.04599 7.11111 9.18729 7.11111 9.33464V24.3346C7.11111 24.482 7.16964 24.6233 7.27383 24.7275C7.37802 24.8317 7.51932 24.8902 7.66667 24.8902H23.2222C23.5278 24.8902 23.7778 24.6408 23.7778 24.3335V9.33575C23.7778 9.02797 23.5278 8.77908 23.2222 8.77908H21.5556V7.66797H23.2222C24.1433 7.66797 24.8889 8.4163 24.8889 9.33575V24.3335C24.8889 24.7757 24.7133 25.1997 24.4008 25.5124C24.0883 25.8252 23.6644 26.001 23.2222 26.0013H7.66667C7.22464 26.0013 6.80072 25.8257 6.48816 25.5132C6.1756 25.2006 6 24.7767 6 24.3346V9.33464C6 8.89261 6.1756 8.46869 6.48816 8.15612C6.80072 7.84356 7.22464 7.66797 7.66667 7.66797H10.4444V8.77908H7.66667ZM19.3333 8.77908H12.6667V7.66797H19.3333V8.77908Z",
    fill: "url(#paint0_linear_3410_9315)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.776 13.7791H7.10938V12.668H23.776V13.7791Z",
    fill: "url(#paint1_linear_3410_9315)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 6.55556C10.4453 6.40821 10.5038 6.26691 10.608 6.16272C10.7122 6.05853 10.8535 6 11.0009 6C11.1482 6 11.2895 6.05853 11.3937 6.16272C11.4979 6.26691 11.5564 6.40821 11.5564 6.55556V9.33334C11.5564 9.48069 11.4979 9.62199 11.3937 9.72618C11.2895 9.83037 11.1482 9.8889 11.0009 9.8889C10.8535 9.8889 10.7122 9.83037 10.608 9.72618C10.5038 9.62199 10.4453 9.48069 10.4453 9.33334V6.55556Z",
    fill: "url(#paint2_linear_3410_9315)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3281 6.55556C19.3281 6.40821 19.3867 6.26691 19.4908 6.16272C19.595 6.05853 19.7363 6 19.8837 6C20.031 6 20.1723 6.05853 20.2765 6.16272C20.3807 6.26691 20.4392 6.40821 20.4392 6.55556V9.33334C20.4392 9.48069 20.3807 9.62199 20.2765 9.72618C20.1723 9.83037 20.031 9.8889 19.8837 9.8889C19.7363 9.8889 19.595 9.83037 19.4908 9.72618C19.3867 9.62199 19.3281 9.48069 19.3281 9.33334V6.55556Z",
    fill: "url(#paint3_linear_3410_9315)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4436 17.5564C14.9721 17.5564 14.5199 17.7437 14.1865 18.0771C13.8531 18.4105 13.6658 18.8627 13.6658 19.3342C13.6658 19.8057 13.8531 20.2579 14.1865 20.5913C14.5199 20.9247 14.9721 21.112 15.4436 21.112C15.9151 21.112 16.3673 20.9247 16.7007 20.5913C17.0341 20.2579 17.2214 19.8057 17.2214 19.3342C17.2214 18.8627 17.0341 18.4105 16.7007 18.0771C16.3673 17.7437 15.9151 17.5564 15.4436 17.5564ZM12.5547 19.3342C12.5547 18.568 12.8591 17.8332 13.4008 17.2914C13.9426 16.7497 14.6774 16.4453 15.4436 16.4453C16.2098 16.4453 16.9446 16.7497 17.4863 17.2914C18.0281 17.8332 18.3325 18.568 18.3325 19.3342C18.3325 20.1004 18.0281 20.8352 17.4863 21.3769C16.9446 21.9187 16.2098 22.2231 15.4436 22.2231C14.6774 22.2231 13.9426 21.9187 13.4008 21.3769C12.8591 20.8352 12.5547 20.1004 12.5547 19.3342Z",
    fill: "url(#paint4_linear_3410_9315)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.4442C14.5 15.2969 14.5585 15.1556 14.6627 15.0514C14.7669 14.9472 14.9082 14.8887 15.0555 14.8887H15.8333C15.9807 14.8887 16.122 14.9472 16.2262 15.0514C16.3304 15.1556 16.3889 15.2969 16.3889 15.4442C16.3889 15.5916 16.3304 15.7329 16.2262 15.8371C16.122 15.9413 15.9807 15.9998 15.8333 15.9998H15.0555C14.9082 15.9998 14.7669 15.9413 14.6627 15.8371C14.5585 15.7329 14.5 15.5916 14.5 15.4442Z",
    fill: "url(#paint5_linear_3410_9315)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8906 17.3895V15.834H16.0017V17.3895H14.8906Z",
    fill: "url(#paint6_linear_3410_9315)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3892 15.8306C17.4934 15.7265 17.6347 15.668 17.782 15.668C17.9293 15.668 18.0706 15.7265 18.1748 15.8306L18.9525 16.6084C19.0537 16.7132 19.1097 16.8535 19.1085 16.9992C19.1072 17.1449 19.0488 17.2842 18.9458 17.3872C18.8428 17.4902 18.7034 17.5487 18.5578 17.5499C18.4121 17.5512 18.2718 17.4952 18.167 17.394L17.3892 16.6162C17.2851 16.512 17.2266 16.3707 17.2266 16.2234C17.2266 16.0761 17.2851 15.9348 17.3892 15.8306Z",
    fill: "url(#paint7_linear_3410_9315)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6094 17.3854L17.776 16.2188L18.5616 17.0043L17.3949 18.1709L16.6094 17.3854Z",
    fill: "url(#paint8_linear_3410_9315)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.329 18.3887C19.4763 18.3887 19.6176 18.4472 19.7218 18.5514C19.826 18.6556 19.8846 18.7969 19.8846 18.9442V19.722C19.8846 19.8694 19.826 20.0107 19.7218 20.1149C19.6176 20.2191 19.4763 20.2776 19.329 20.2776C19.1817 20.2776 19.0403 20.2191 18.9362 20.1149C18.832 20.0107 18.7734 19.8694 18.7734 19.722V18.9442C18.7734 18.7969 18.832 18.6556 18.9362 18.5514C19.0403 18.4472 19.1817 18.3887 19.329 18.3887Z",
    fill: "url(#paint9_linear_3410_9315)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2266 19.3329C17.2266 19.1856 17.2851 19.0443 17.3893 18.9401C17.4935 18.8359 17.6348 18.7773 17.7821 18.7773H19.3377C19.485 18.7773 19.6263 18.8359 19.7305 18.9401C19.8347 19.0443 19.8932 19.1856 19.8932 19.3329C19.8932 19.4803 19.8347 19.6216 19.7305 19.7258C19.6263 19.8299 19.485 19.8885 19.3377 19.8885H17.7821C17.6348 19.8885 17.4935 19.8299 17.3893 19.7258C17.2851 19.6216 17.2266 19.4803 17.2266 19.3329Z",
    fill: "url(#paint10_linear_3410_9315)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3423 21.2759C19.4465 21.3801 19.505 21.5214 19.505 21.6687C19.505 21.816 19.4465 21.9573 19.3423 22.0615L18.5645 22.8393C18.5133 22.8923 18.452 22.9347 18.3842 22.9638C18.3164 22.9929 18.2435 23.0082 18.1698 23.0089C18.096 23.0095 18.0228 22.9954 17.9546 22.9675C17.8863 22.9396 17.8243 22.8983 17.7721 22.8462C17.7199 22.794 17.6787 22.732 17.6507 22.6637C17.6228 22.5954 17.6087 22.5223 17.6094 22.4485C17.61 22.3747 17.6254 22.3018 17.6545 22.234C17.6836 22.1663 17.7259 22.105 17.779 22.0537L18.5568 21.2759C18.6609 21.1718 18.8022 21.1133 18.9495 21.1133C19.0968 21.1133 19.2381 21.1718 19.3423 21.2759Z",
    fill: "url(#paint11_linear_3410_9315)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7856 20.498L18.9522 21.6647L18.1667 22.4503L17 21.2836L17.7856 20.498Z",
    fill: "url(#paint12_linear_3410_9315)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 23.2235C14.5 23.0762 14.5585 22.9349 14.6627 22.8307C14.7669 22.7265 14.9082 22.668 15.0555 22.668H15.8333C15.9807 22.668 16.122 22.7265 16.2262 22.8307C16.3304 22.9349 16.3889 23.0762 16.3889 23.2235C16.3889 23.3709 16.3304 23.5122 16.2262 23.6164C16.122 23.7206 15.9807 23.7791 15.8333 23.7791H15.0555C14.9082 23.7791 14.7669 23.7206 14.6627 23.6164C14.5585 23.5122 14.5 23.3709 14.5 23.2235Z",
    fill: "url(#paint13_linear_3410_9315)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4462 21.1133C15.5935 21.1133 15.7348 21.1718 15.839 21.276C15.9432 21.3802 16.0017 21.5215 16.0017 21.6688V23.2244C16.0017 23.3717 15.9432 23.513 15.839 23.6172C15.7348 23.7214 15.5935 23.7799 15.4462 23.7799C15.2988 23.7799 15.1575 23.7214 15.0533 23.6172C14.9492 23.513 14.8906 23.3717 14.8906 23.2244V21.6688C14.8906 21.5215 14.9492 21.3802 15.0533 21.276C15.1575 21.1718 15.2988 21.1133 15.4462 21.1133Z",
    fill: "url(#paint14_linear_3410_9315)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9361 21.2759C12.0403 21.1718 12.1816 21.1133 12.3289 21.1133C12.4762 21.1133 12.6175 21.1718 12.7217 21.2759L13.4994 22.0537C13.6006 22.1585 13.6566 22.2988 13.6554 22.4445C13.6541 22.5901 13.5957 22.7295 13.4927 22.8325C13.3897 22.9355 13.2503 22.9939 13.1047 22.9952C12.959 22.9965 12.8187 22.9405 12.7139 22.8393L11.9361 22.0615C11.8319 21.9573 11.7734 21.816 11.7734 21.6687C11.7734 21.5214 11.8319 21.3801 11.9361 21.2759Z",
    fill: "url(#paint15_linear_3410_9315)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2804 21.2836L13.1137 22.4503L12.3281 21.6647L13.4948 20.498L14.2804 21.2836Z",
    fill: "url(#paint16_linear_3410_9315)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5556 18.3887C11.7029 18.3887 11.8442 18.4472 11.9484 18.5514C12.0526 18.6556 12.1111 18.7969 12.1111 18.9442V19.722C12.1111 19.8694 12.0526 20.0107 11.9484 20.1149C11.8442 20.2191 11.7029 20.2776 11.5556 20.2776C11.4082 20.2776 11.2669 20.2191 11.1627 20.1149C11.0585 20.0107 11 19.8694 11 19.722V18.9442C11 18.7969 11.0585 18.6556 11.1627 18.5514C11.2669 18.4472 11.4082 18.3887 11.5556 18.3887Z",
    fill: "url(#paint17_linear_3410_9315)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19.3329C11 19.1856 11.0585 19.0443 11.1627 18.9401C11.2669 18.8359 11.4082 18.7773 11.5556 18.7773H13.1111C13.2585 18.7773 13.3998 18.8359 13.504 18.9401C13.6081 19.0443 13.6667 19.1856 13.6667 19.3329C13.6667 19.4803 13.6081 19.6216 13.504 19.7258C13.3998 19.8299 13.2585 19.8885 13.1111 19.8885H11.5556C11.4082 19.8885 11.2669 19.8299 11.1627 19.7258C11.0585 19.6216 11 19.4803 11 19.3329Z",
    fill: "url(#paint18_linear_3410_9315)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5083 15.8306C13.6125 15.9348 13.671 16.0761 13.671 16.2234C13.671 16.3707 13.6125 16.512 13.5083 16.6162L12.7306 17.394C12.6258 17.4952 12.4855 17.5512 12.3398 17.5499C12.1941 17.5487 12.0548 17.4902 11.9518 17.3872C11.8488 17.2842 11.7903 17.1449 11.7891 16.9992C11.7878 16.8535 11.8438 16.7132 11.945 16.6084L12.7228 15.8306C12.827 15.7265 12.9683 15.668 13.1156 15.668C13.2629 15.668 13.4042 15.7265 13.5083 15.8306Z",
    fill: "url(#paint19_linear_3410_9315)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4948 18.1709L12.3281 17.0043L13.1137 16.2188L14.2804 17.3854L13.4948 18.1709Z",
    fill: "url(#paint20_linear_3410_9315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9315",
    x1: 23.3568,
    y1: 7.66797,
    x2: 12.479,
    y2: 19.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3410_9315",
    x1: 22.4242,
    y1: 12.668,
    x2: 22.3405,
    y2: 13.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3410_9315",
    x1: 11.4663,
    y1: 6,
    x2: 10.1928,
    y2: 6.38185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3410_9315",
    x1: 20.3491,
    y1: 6,
    x2: 19.0756,
    y2: 6.38185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3410_9315",
    x1: 17.8638,
    y1: 16.4453,
    x2: 14.4292,
    y2: 20.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3410_9315",
    x1: 16.2357,
    y1: 14.8887,
    x2: 15.6716,
    y2: 15.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3410_9315",
    x1: 15.9116,
    y1: 15.834,
    x2: 15.023,
    y2: 16.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3410_9315",
    x1: 18.9559,
    y1: 15.668,
    x2: 17.8371,
    y2: 16.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3410_9315",
    x1: 18.4032,
    y1: 16.2188,
    x2: 17.2427,
    y2: 17.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3410_9315",
    x1: 19.7944,
    y1: 18.3887,
    x2: 18.7894,
    y2: 19.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3410_9315",
    x1: 19.6769,
    y1: 18.7773,
    x2: 19.2233,
    y2: 19.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3410_9315",
    x1: 19.3512,
    y1: 21.1133,
    x2: 18.2244,
    y2: 22.2959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3410_9315",
    x1: 18.7939,
    y1: 20.498,
    x2: 17.6333,
    y2: 21.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3410_9315",
    x1: 16.2357,
    y1: 22.668,
    x2: 15.6716,
    y2: 23.6744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3410_9315",
    x1: 15.9116,
    y1: 21.1133,
    x2: 14.7464,
    y2: 21.6228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3410_9315",
    x1: 13.5027,
    y1: 21.1133,
    x2: 12.384,
    y2: 22.2874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3410_9315",
    x1: 14.122,
    y1: 20.498,
    x2: 12.9615,
    y2: 21.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3410_9315",
    x1: 12.021,
    y1: 18.3887,
    x2: 11.016,
    y2: 19.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3410_9315",
    x1: 13.4504,
    y1: 18.7773,
    x2: 12.9968,
    y2: 19.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3410_9315",
    x1: 13.5184,
    y1: 15.668,
    x2: 12.3996,
    y2: 16.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3410_9315",
    x1: 14.122,
    y1: 16.2187,
    x2: 12.9615,
    y2: 17.4366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarantine);
export default __webpack_public_path__ + "static/media/quarantine.f75fa144.svg";
export { ForwardRef as ReactComponent };